import { useCallback, useContext, useRef } from 'react';
import { CruiseSelectionContext } from 'contexts/CruiseSelectionContext';
// import { CruiseSearchContext } from 'contexts/CruiseSearchContext';

import { gsap } from 'gsap';

const useAnimationFilterCardShip = ({ index, shipRef }) => {
  const { isMobile } = useContext(CruiseSelectionContext);
  const isIntersected = useRef(false);
  const even = index % 2 === 0;
  let delay = even ? 0.1 : 0.2;
  if (!isMobile) {
    delay = 0.02 * index;
  }
  const onUpdate = useCallback(
    ({ progress }) => {
      const doIn = progress > 0.1 && progress < 0.8;
      const doOut = progress <= 0.1;
      if (doIn) {
        if (!isIntersected.current) {
          animateIn();
          isIntersected.current = true;
        }
      }
      if (doOut) {
        if (isIntersected.current) {
          isIntersected.current = false;
          animateOut();
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isMobile],
  );

  const animateIn = () => {
    gsap.killTweensOf([shipRef.current]);
    gsap.set(shipRef.current, {
      opacity: 0,
      x: '20px',
    });
    gsap.to(shipRef.current, {
      opacity: 1,
      x: '0px',
      duration: 0.4,
      delay,
      ease: 'cubic-bezier(0,0,0,0)',
    });
  };

  const animateOut = () => {
    gsap.to(shipRef.current, {
      opacity: 0,
      x: '-20px',
      duration: 0.2,
      delay,
      ease: 'cubic-bezier(0,0,0,0)',
    });
  };

  return { onUpdate };
};

export default useAnimationFilterCardShip;
